import React, { PureComponent } from "react";
import { scaleLinear } from "d3-scale";
import * as array from "d3-array";

export interface YAxisProps {
  scale?: any;
  numberOfTicks?: number;
  contentInset?: any;
  data: any;
  spacingInner?: number;
  spacingOuter?: number;
  formatLabel?: any;
  yAccessor?: any;
  svg?: any;
  min?: any;
  max?: any;
  style?: any;
  height?: any;
}

export interface YAxisState {
  height: number;
  widthStyle: any;
  hideText: boolean;
}

class YAxis extends PureComponent<YAxisProps, YAxisState> {
  constructor(props: YAxisProps) {
    super(props);
    this.state = {
      height: 0,
      widthStyle: {
        width: 0,
      },
      hideText: false,
    };
  }

  _onLayout(event: any) {
    const {
      nativeEvent: {
        layout: { height },
      },
    } = event;
    this.setState({ height });
  }

  _onLayoutWidth(event: any, last: boolean) {
    const {
      nativeEvent: {
        layout: { width },
      },
    } = event;
    if (this.state.widthStyle.width < width) {
      this.setState({ widthStyle: { width }, hideText: last });
    } else if (last) {
      this.setState({ hideText: true });
    }
  }

  getY(domain: any) {
    const {
      numberOfTicks,
      contentInset: { top = 0, bottom = 0 },
    } = this.props;
    const { height } = this.props;
    const y = scaleLinear()
      .domain(domain)
      .range([height - bottom, top])
      .nice(numberOfTicks);

    return y;
  }

  render() {
    const { style, data, yAccessor, numberOfTicks, formatLabel, min, max, svg, height } = this.props;
    if (data.length === 0) {
      return <div style={style} />;
    }
    const values = data.map((item: any, index: number) => yAccessor({ item, index }));
    const extent = array.extent([...values, max, min]);
    const domain = [max || extent[1], min || extent[0]];
    const y = this.getY(domain);
    const ticks = y.ticks(numberOfTicks);
    return (
      <div className="rotoql-chart__y-axis" style={{ height }}>
        <div>
          {ticks.map((value: any, index: number) => {
            return (
              <p
                key={index}
                /*
                onLayout={event =>
                  this._onLayoutWidth(event, ticks.length - 1 === index)
                }*/
                style={{
                  //color: "transparent",
                  fontSize: svg.fontSize,
                }}
              >
                {formatLabel(value, index)}
              </p>
            );
          })}
        </div>
      </div>
    );
  }
}

export default YAxis;
